const styles = theme => ({
  root: {
    padding: '33px 24px',
    marginBottom: theme.spacing.unit * 1.5,
    backgroundColor: 'rgb(236, 238, 241)',
    borderRadius: '0 0 2px 2px'
  },
  inputs: {
    marginBottom: theme.spacing.unit * 3,
    '&:last-child': {
      marginBottom: '0 !important'
    }
  }
});

export default styles;
